import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import classNames from 'classnames';

class Accordion extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            expanded: props.initialExpanded,
        };
    }

    toggleExpandedState = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        const { expanded } = this.state;
        const { header, children } = this.props;
        const className = classNames('ui-accordion__header',
            expanded && 'ui-accordion__header_active');

        return (
            <section className="ui-accordion__row">
                <button
                    className={className}
                    onClick={this.toggleExpandedState}
                >
                    <h2 className="ui-accordion__title">{header}</h2>
                    <Svg
                        iconName="minus"
                        size="Medium"
                        className="ui-icon accordionMinus ui-accordion__arrow"
                    />
                    <Svg
                        iconName="plus"
                        size="Medium"
                        className="ui-icon accordionPlus ui-accordion__arrow"
                    />
                </button>
                {expanded &&
                    <div className="ui-accordion__content">
                        {children}
                    </div>
                }
            </section>
        );
    }
}

Accordion.defaultProps = {
    initialExpanded: false,
};

Accordion.propTypes = {
    header: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    initialExpanded: PropTypes.bool,
};

export default Accordion;



// WEBPACK FOOTER //
// ./src/js/shared/Accordion.jsx